import { widgetHotStampingDefault } from 'components/layout_and_quote_builder/quote_builder/widgetHotStampingDefault';

const SAVED_USER_PRICE_ID_NAMES = [
  'hot_stamping_material_user_price_id',
  'hot_stamping_printing_block_user_price_id',
  'hot_stamping_machine_user_price_id',
];

// Mirrors Calculators::Base#user_price_id_given?.
const userPriceIdGiven = (id) => id != undefined && id !== '' && id !== 'not-available' && id !== 'new-attribute';

// The Hot stamping section's "None / Yes" question on a section with no saved answer: a quote priced before the
// question existed opens on Yes when its saved section (each QuoteBuilderForm tree passes its own) or the widget's
// hot stamping on this column has a hot stamping price, so it is not unpriced on its first post.
export function hotStampingAppliedDefault(savedSection, navSection, item) {
  const savedIds = SAVED_USER_PRICE_ID_NAMES.map((name) => savedSection?.[name]);
  const widgetMaterialId = widgetHotStampingDefault(navSection, item, 'material_user_price_id');

  return [...savedIds, widgetMaterialId].some(userPriceIdGiven) ? 'applied' : 'none';
}
